"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkmark = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Checkmark = function Checkmark(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.7711006,6.65351957 C18.6253718,6.49124106 18.4272462,6.4 18.220595,6.4 C18.0139438,6.4 17.8158182,6.49124106 17.6700894,6.65351957 L9.66389265,15.520853 L6.32903804,11.8202568 C6.0250022,11.4835192 5.53206271,11.4835192 5.22802688,11.8202568 C4.92399104,12.1569943 4.92399104,12.7029538 5.22802688,13.0396913 L9.11656918,17.3464804 C9.26229796,17.5087589 9.46042355,17.6 9.66707476,17.6 C9.87372598,17.6 10.0718516,17.5087589 10.2175803,17.3464804 L18.7711006,7.87295413 C18.9176197,7.71155094 19,7.49211522 19,7.26323685 C19,7.03435849 18.9176197,6.81492276 18.7711006,6.65351957 Z"
  }));
};

exports.Checkmark = Checkmark;